import { api } from "@/builders/axios";
import {
  CreateResource,
  CreateResourceResponse,
  ResourcesList,
} from "@/builders/types/resources";

const list = async (params?: { course?: number }) => {
  return api
    .get<ResourcesList>("resources", { params })
    .then(({ data }) => data);
};

const post = function (data: CreateResource) {
  return api
    .post<CreateResourceResponse>("resources", data)
    .then(({ data }) => data);
};

export const resources = { list, post };
